module.exports = __webpack_public_path__ + "assets/img/forest.386d4f90.png";